// import React, {Component} from 'react';
import MainPage from '../MainPage';
import {connect} from 'react-redux';

function mapReduxStateToReactProps(state) {
  return state
}
export default connect(mapReduxStateToReactProps)(MainPage);

